import React from "react";
import { Heart } from "lucide-react";

const LABEL = {
  sk: "Podporovateľ Tréningového centra SauberEko",
  en: "SauberEko Training Centre supporter",
  cs: "Podporovatel Tréninkového centra SauberEko",
  de: "Unterstützer des SauberEko Trainingszentrums",
  pl: "Wspierający Centrum Szkoleniowe SauberEko",
  fr: "Soutien du Centre de formation SauberEko",
};

export default function SupporterBadge({ lang = "sk" }) {
  const label = LABEL[lang] || LABEL.sk;
  return (
    <span
      data-testid="supporter-badge"
      title={label}
      aria-label={label}
      className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-gradient-to-br from-amber-300 via-yellow-200 to-amber-500 shadow-[0_0_8px_-1px_rgba(251,191,36,0.9)] ring-1 ring-amber-200/50 flex-shrink-0"
    >
      <Heart className="w-2.5 h-2.5 text-amber-900" fill="currentColor" strokeWidth={2.5} />
    </span>
  );
}
